import React, { useState } from "react";

const RentalCalculator = () => {
  const stripLeadingZeros = (value) => {
    const stripped = value.replace(/^0+(?!$)/, "");
        return stripped === "" ? "0" : stripped;
    };
  const [valueAppreciationError, setValueAppreciationError] = useState("");
  const [costToSellError, setCostToSellError] = useState("");
  const [hoaFeeError, setHoaFeeError] = useState("");
  const [maintenanceError, setMaintenanceError] = useState("");
  const [otherCostsError, setOtherCostsError] = useState("");
  const [propertyTaxError, setPropertyTaxError] = useState("");
  const [insuranceError, setInsuranceError] = useState("");
  const [monthlyRentError, setMonthlyRentError] = useState("");
  const [closingCostError, setClosingCostError] = useState("");
  const [purchasePriceError, setPurchasePriceError] = useState("");
  const [purchasePrice, setPurchasePrice] = useState(1000000);

  const [downPaymentPercent, setDownPaymentPercent] = useState(20);
  const [downPayment, setDownPayment] = useState(0);
  const [interestRate, setInterestRate] = useState(6);
  const [loanTerm, setLoanTerm] = useState(30);
  const [closingCostPercent, setClosingCostPercent] = useState(3);
  
  const [monthlyRent, setMonthlyRent] = useState(5000);
  const [otherIncome, setOtherIncome] = useState(0);
  const [vacancyRate, setVacancyRate] = useState(5);
  const [monthlyRentIncrease, setMonthlyRentIncrease] = useState(3);
  const [otherIncomeIncrease, setOtherIncomeIncrease] = useState(3);
  const [propertyManagement, setPropertyManagement] = useState(10);


  const [propertyTax, setPropertyTax] = useState(3000);
  const [insurance, setInsurance] = useState(1200);
  const [hoaFee, setHoaFee] = useState(0);
  const [maintenance, setMaintenance] = useState(2000);
  const [otherCosts, setOtherCosts] = useState(500);
  const [expenseIncrease, setExpenseIncrease] = useState(3);
  
  const [knowSellPrice, setKnowSellPrice] = useState(false);
  const [sellingPrice, setSellingPrice] = useState(0);
  const [valueAppreciation, setValueAppreciation] = useState(3);
  const [holdingLength, setHoldingLength] = useState(20);
  const [costToSell, setCostToSell] = useState(8);

  const inputClass = "w-full rounded border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400";
  
  //const downPayment = (purchasePrice * downPaymentPercent) / 100;
  const closingCost = (purchasePrice * closingCostPercent) / 100;
  const loanAmount = purchasePrice - downPayment;
  const loanTermMonths = loanTerm * 12;
  const monthlyInterestRate = interestRate / 100 / 12;

  const monthlyLoanPayment = loanAmount > 0
    ? loanAmount * monthlyInterestRate / (1 - Math.pow(1 + monthlyInterestRate, -loanTermMonths))
    : 0;
  const annualLoanPayment = monthlyLoanPayment * 12;

  const grossAnnualIncome = (monthlyRent + otherIncome) * 12;
  const adjustedGrossIncome = grossAnnualIncome * (1 - vacancyRate / 100);
  const totalManagementCost = adjustedGrossIncome * (propertyManagement / 100);
  const hoaAnnual = hoaFee * 12;
  const operatingExpenses = propertyTax + insurance + hoaAnnual + maintenance + otherCosts ;
  const annualCashFlow = adjustedGrossIncome - operatingExpenses - annualLoanPayment - totalManagementCost;
  const annualCashFlowArray = [];
  const totalRentalIncome = Array.from({ length: holdingLength }).reduce((acc, _, year) => {
    const rent = monthlyRent * Math.pow(1 + monthlyRentIncrease / 100, year);
    const other = otherIncome * Math.pow(1 + otherIncomeIncrease / 100, year);
    const annualGross = (rent + other) * 12;
    const netAfterVacancy = annualGross * (1 - vacancyRate / 100);
    const netAfterManagement = netAfterVacancy * (1 - propertyManagement / 100);
    // console.log(`Year ${year + 1}:`);
    // console.log(`  Rent: $${rent.toFixed(2)} / Other: $${other.toFixed(2)}`);
    // console.log(`  Annual Gross Income: $${annualGross.toFixed(2)}`);
    // console.log(`  Net After Vacancy: $${netAfterVacancy.toFixed(2)}`);
    // console.log(`  Accumulated Total: $${(acc + netAfterVacancy).toFixed(2)}`);
    // console.log('----------------------');
    return acc + netAfterManagement;
  }, 0);

 // const averageAnnualIncome = totalRentalIncome / holdingLength;
  

  const totalOperatingExpenses = Array.from({ length: holdingLength }).reduce((acc, _, year) => {
    const inflatedExpense = operatingExpenses * Math.pow(1 + expenseIncrease / 100, year);
    return acc + inflatedExpense ;
  }, 0);

  const totalNOI = totalRentalIncome - totalOperatingExpenses;

  const projectedSellingPrice = knowSellPrice
    ? sellingPrice
    : purchasePrice * Math.pow(1 + valueAppreciation / 100, holdingLength);

  const saleProceeds = projectedSellingPrice * (1 - costToSell / 100);
  const totalLoanPayments = annualLoanPayment * holdingLength;
  console.log("totalLoanPayments", totalLoanPayments,annualLoanPayment);
  const monthsPaid = holdingLength * 12;
  const remainingLoanBalance = loanAmount > 0
  ? loanAmount * Math.pow(1 + monthlyInterestRate, monthsPaid) -
    monthlyLoanPayment * ((Math.pow(1 + monthlyInterestRate, monthsPaid) - 1) / monthlyInterestRate)
  : 0;



 


  
 


  const totalInvestment = downPayment + closingCost;
  //console.log("totalInvestment", totalInvestment);
  //const averageAnnualCashFlow = (totalNOI - totalLoanPayments) / holdingLength;

  //const cashOnCashReturn = totalInvestment > 0 ? ((averageAnnualCashFlow * holdingLength) / totalInvestment) * 100 : 0;
  const capRate = purchasePrice > 0 ? (totalNOI / holdingLength / purchasePrice) * 100 : 0;
  let totalReturn = 0;
let negativeCashFlow = 0;

Array.from({ length: holdingLength }).forEach((_, year) => {
  const rent = monthlyRent * Math.pow(1 + monthlyRentIncrease / 100, year);
  const other = otherIncome * Math.pow(1 + otherIncomeIncrease / 100, year);
  const annualGross = (rent + other) * 12;
  const netIncome = annualGross * (1 - vacancyRate / 100);

  const managementCost = netIncome * (propertyManagement / 100);
  const expenses = propertyTax + insurance + hoaFee * 12 + maintenance + otherCosts;
  const grownExpenses = expenses * Math.pow(1 + expenseIncrease / 100, year)+managementCost;

  const cashFlow = netIncome - grownExpenses - annualLoanPayment;
  annualCashFlowArray.push(cashFlow);
  if (cashFlow < 0) negativeCashFlow += Math.abs(cashFlow);
  if (cashFlow > 0) totalReturn += cashFlow;
  //console.log("cashflows",year, cashFlow, "netIncome",year, netIncome,expenses);
  //console.log();
});

  const totalCashSpent = totalInvestment + negativeCashFlow;
  const totalProfit = totalReturn + saleProceeds - totalCashSpent - remainingLoanBalance;
  //const totalCashReturn = totalProfit - totalCashSpent;
  const cashOnCashReturn = totalInvestment > 0 ? (totalProfit / totalInvestment) * 100 : 0;
  //console.log("totalCashSpent", totalCashSpent);
  const cashFlows = [
    -totalCashSpent,
    ...annualCashFlowArray.slice(0, holdingLength - 1),
    annualCashFlowArray[holdingLength - 1] + (saleProceeds - remainingLoanBalance)
  ];
  
  function computeIRR(cashFlows, initialGuess = 0.1) {
    const maxIterations = 99;
    const precision = 1e-6;
    let rate = initialGuess;
  
    // Check for at least one sign change
    const hasSignChange = cashFlows.some((val, i, arr) =>
      i > 0 && val * arr[i - 1] < 0
    );
    if (!hasSignChange) return NaN;
  
    // Newton-Raphson Method
    for (let i = 0; i < maxIterations; i++) {
      let npv = 0;
      let derivative = 0;
  
      for (let t = 0; t < cashFlows.length; t++) {
        const denom = Math.pow(1 + rate, t);
        npv += cashFlows[t] / denom;
        if (t > 0) {
          derivative -= t * cashFlows[t] / Math.pow(1 + rate, t + 1);
        }
      }
  
      // If derivative is too small, fallback
      if (Math.abs(derivative) < 1e-10) break;
  
      const newRate = rate - npv / derivative;
      if (Math.abs(newRate - rate) < precision) return newRate * 100;
      rate = newRate;
    }
  
    // 🔁 Fallback: Brute-force search between -99% and 200%
    const lowerBound = -0.99;
    const upperBound = 2.0;
    const step = 0.0001;
    let bestRate = NaN;
    let minNPV = Infinity;
  
    for (let r = lowerBound; r <= upperBound; r += step) {
      let npv = 0;
      for (let t = 0; t < cashFlows.length; t++) {
        npv += cashFlows[t] / Math.pow(1 + r, t);
      }
  
      if (Math.abs(npv) < Math.abs(minNPV)) {
        minNPV = npv;
        bestRate = r;
      }
  
      // Stop early if close enough to 0
      if (Math.abs(npv) < precision) break;
    }
  
    return isNaN(bestRate) ? NaN : bestRate * 100;
  }
  
  // function computeIRR(cashFlows, guess = 0.1) {
  //   const maxIterations = 100;
  //   const precision = 1e-6;
  //   let rate = guess;
  
  //   for (let i = 0; i < maxIterations; i++) {
  //     let npv = 0;
  //     let derivative = 0;
  
  //     for (let t = 0; t < cashFlows.length; t++) {
  //       npv += cashFlows[t] / Math.pow(1 + rate, t);
  //       if (t > 0) {
  //         derivative -= t * cashFlows[t] / Math.pow(1 + rate, t + 1);
  //       }
  //     }
  
  //     const newRate = rate - npv / derivative;
  //     if (Math.abs(newRate - rate) < precision) return newRate * 100;
  //     rate = newRate;
  //   }
  
  //   return NaN;
  // }
  
  const irr = computeIRR(cashFlows);
  //const annualCashFlow = averageAnnualCashFlow; // for table display


  // const annualCashFlow = adjustedGrossIncome - operatingExpenses - annualLoanPayment;
  // const totalInvestment = downPayment + closingCost;

  // const cashOnCashReturn = totalInvestment > 0 ? (annualCashFlow / totalInvestment) * 100 : 0;
  // const roi = purchasePrice > 0 ? (annualCashFlow / purchasePrice) * 100 : 0;
  // const projectedSellingPrice = knowSellPrice
  // ? sellingPrice
  // : purchasePrice * Math.pow(1 + valueAppreciation / 100, holdingLength);

  // const saleProceeds = projectedSellingPrice * (1 - costToSell / 100);
  // const totalOperatingExpenses = Array.from({ length: holdingLength }).reduce((acc, _, year) => {
  //   const inflatedExpense = operatingExpenses * Math.pow(1 + expenseIncrease / 100, year);
  //   return acc + inflatedExpense;
  // }, 0);

  // const totalRentalIncome = Array.from({ length: holdingLength }).reduce((acc, _, year) => {
  //   const rent = monthlyRent * Math.pow(1 + monthlyRentIncrease / 100, year);
  //   const other = otherIncome * Math.pow(1 + otherIncomeIncrease / 100, year);
  //   const annualGross = (rent + other) * 12;
  //   const netAfterVacancy = annualGross * (1 - vacancyRate / 100);
  //   return acc + netAfterVacancy;
  // }, 0);
  
  
  


  // const totalNOI = totalRentalIncome - totalOperatingExpenses;

  // const totalProfit = saleProceeds - purchasePrice; // Already defined above
  
return (
 
<div className="mt-10 p-6 bg-white rounded-xl shadow-md border border-gray-200 max-w-4xl">
  <h2 className="text-2xl sm:text-3xl font-semibold mb-6 text-gray-800 text-left tracking-tight">Property Rental Income Estimation</h2>

 {/* Purchase Section */}
<div className="mb-6">
  <h3 className="text-lg font-semibold text-gray-700 mb-2">Purchase</h3>
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    
  <div className="w-full">
      <label className="text-sm font-medium text-gray-700 mb-1 block">Home Purchase Price</label>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
        <input
          type="text"
          value={purchasePrice.toLocaleString()}
          onChange={(e) => {
            const val = e.target.value.replace(/[^0-9]/g, "");
            setPurchasePriceError(!val || Number(val) < 0 ? "Invalid property tax" : "");
            setPurchasePrice(Number(val));
          }}
          className="w-full h-[42px] rounded border pl-6 pr-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
        />
      </div>
      {purchasePriceError && <p className="text-xs text-red-600 mt-1">{purchasePriceError}</p>}
    </div>






    

    {/* Down Payment */}
    <div>
      <label className="text-sm font-medium text-gray-700 mb-1 block">Down Payment</label>
      <div className="relative">

        <input
          type="text"
          value={downPayment.toLocaleString()}
          onChange={(e) =>{
            const val = e.target.value.replace(/[^0-9]/g, "");
            setDownPayment(!val || Number(val) < 0 ? "Invalid Down Payment" : "");
            setDownPayment(Number(val));
          }}
          className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
        />
        <span className="absolute right-3 top-2.5 text-gray-500 text-sm">
              {purchasePrice > 0 ? ((downPayment / purchasePrice) * 100).toFixed(1) + '%' : ''}
        </span>
      </div>
    </div>
    {/* <div>
      <label className="text-sm font-medium text-gray-700 mb-1 block">Down Payment (%)</label>
      <div className="relative">
        <input
          type="number"
          step="any"
          value={downPaymentPercent.toLocaleString()}
          onChange={(e) =>
            setDownPaymentPercent(Number(e.target.value.replace(/[^0-9.]/g, "")))
          }
          className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">%</span>
      </div>
    </div> */}

    {/* Interest Rate */}
    <div>
      <label className="text-sm font-medium text-gray-700 mb-1 block">Interest Rate (%)</label>
      <div className="relative">
        <input
          type="number"
          step="any"
          value={interestRate.toLocaleString()}
          onChange={(e) =>
            setInterestRate(Number(e.target.value.replace(/[^0-9.]/g, "")))
          }
          className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300
          [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">%</span>
      </div>
    </div>

    {/* Loan Term */}
    <div>
      <label className="text-sm font-medium text-gray-700 mb-1 block">Loan Term (years)</label>
      <select
        value={loanTerm}
        onChange={(e) => setLoanTerm(Number(e.target.value))}
        className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
      >
        {[10, 15, 30].map((term) => (
          <option key={term} value={term}>{term}</option>
        ))}
      </select>
    </div>

    {/* Closing Cost */}
    <div>
      <label className="text-sm font-medium text-gray-700 mb-1 block">Closing Cost (%)</label>
      <div className="relative">
        <input
          type="number"
          step="any"
          value={closingCostPercent.toLocaleString()}
          onChange={(e) =>
            setClosingCostPercent(Number(e.target.value.replace(/[^0-9.]/g, "")))
          }
          className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300
          [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">%</span>
      </div>
    </div>
  </div>
</div>


 
{/* Income Section */}
<div className="mb-6">
  <h3 className="text-lg font-semibold text-gray-700 mb-2">Income</h3>
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

    {/* Monthly Rent */}
    <div className="w-full">
      <label className="text-sm font-medium text-gray-700 mb-1 block">Monthly Rent</label>
      <div className="relative mb-3">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
        <input
          type="text"
          value={monthlyRent.toLocaleString()}
          onChange={(e) => {
            const val = e.target.value.replace(/[^0-9]/g, "");
            setMonthlyRent(Number(val));
          }}
          className="w-full h-[42px] rounded border pl-6 pr-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
        />
      </div>

      <div className="relative">
        <label className="text-sm text-gray-600 mb-1 block">Monthly Rent Annual Increase(%)</label>
        <input
          type="number"
          step="any"
          value={monthlyRentIncrease.toLocaleString()}
          onChange={(e) => setMonthlyRentIncrease(Number(e.target.value))}
          className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300
          [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        />
        
      </div>
    </div>

    {/* Other Monthly Income */}
    <div className="w-full">
      <label className="text-sm font-medium text-gray-700 mb-1 block">Other Monthly Income</label>
      <div className="relative mb-3">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
        <input
          type="text"
          value={otherIncome.toLocaleString()}
          onChange={(e) => {
            const val = e.target.value.replace(/[^0-9]/g, "");
            setOtherIncome(Number(val));
          }}
          className="w-full h-[42px] rounded border pl-6 pr-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
        />
      </div>

      <div className="relative">
        <label className="text-sm text-gray-600 mb-1 block">Other Monthly Income Annual Increase(%)</label>
        <input
          type="number"
          step="any"
          value={otherIncomeIncrease.toLocaleString()}
          onChange={(e) => setOtherIncomeIncrease(Number(e.target.value))}
          className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300
          [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        />
        

      </div>
    </div>

    {/* Vacancy Rate */}

    <div className="w-full">
        <label className="text-sm font-medium text-gray-700 mb-1 block">Vacancy Rate (%)</label>
        <div className="relative">
          <input
            type="number"
            step="any"
            value={vacancyRate.toLocaleString()}
            onChange={(e) => setVacancyRate(Number(e.target.value))}
            className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300
          [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">%</span>
        </div>
    </div>
    <div className="w-full">
        <label className="text-sm font-medium text-gray-700 mb-1 block">Management Fee (%)</label>
        <div className="relative">
          <input
            type="number"
            step="any"
            value={propertyManagement.toLocaleString()}
            onChange={(e) =>  setPropertyManagement(Number(e.target.value))}
            className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300
          [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">%</span>
        </div>
    </div>
  </div>
</div>



{/* Expenses Section */}
<div className="mb-6">
  <h3 className="text-lg font-semibold text-gray-700 mb-2">Recurring Operating Expenses</h3>
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

    {/* Property Tax */}
    <div className="w-full">
      <label className="text-sm font-medium text-gray-700 mb-1 block">Property Tax (Annual)</label>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
        <input
          type="text"
          value={propertyTax.toLocaleString()}
          onChange={(e) => {
            const val = e.target.value.replace(/[^0-9]/g, "");
            setPropertyTaxError(!val || Number(val) < 0 ? "Invalid property tax" : "");
            setPropertyTax(Number(val));
          }}
          className="w-full h-[42px] rounded border pl-6 pr-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
        />
      </div>
      {propertyTaxError && <p className="text-xs text-red-600 mt-1">{propertyTaxError}</p>}
    </div>

    {/* Insurance */}
    <div className="w-full">
      <label className="text-sm font-medium text-gray-700 mb-1 block">Insurance (Annual)</label>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
        <input
          type="text"
          value={insurance.toLocaleString()}
          onChange={(e) => {
            const val = e.target.value.replace(/[^0-9]/g, "");
            setInsuranceError(!val || Number(val) < 0 ? "Invalid insurance" : "");
            setInsurance(Number(val));
          }}
          className="w-full h-[42px] rounded border pl-6 pr-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
        />
      </div>
      {insuranceError && <p className="text-xs text-red-600 mt-1">{insuranceError}</p>}
    </div>

    {/* HOA Fee */}
    <div className="w-full">
      <label className="text-sm font-medium text-gray-700 mb-1 block">HOA Fee (Monthly)</label>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
        <input
          type="text"
          value={hoaFee.toLocaleString()}
          onChange={(e) => {
            const val = e.target.value.replace(/[^0-9]/g, "");
            setHoaFeeError(!val || Number(val) < 0 ? "Invalid HOA Fee" : "");
            setHoaFee(Number(val));
          }}
          className="w-full h-[42px] rounded border pl-6 pr-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
        />
      </div>
      {hoaFeeError && <p className="text-xs text-red-600 mt-1">{hoaFeeError}</p>}
    </div>

    {/* Maintenance */}
    <div className="w-full">
      <label className="text-sm font-medium text-gray-700 mb-1 block">Maintenance (Annual)</label>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
        <input
          type="text"
          value={maintenance.toLocaleString()}
          onChange={(e) => {
            const val = e.target.value.replace(/[^0-9]/g, "");
            setMaintenanceError(!val || Number(val) < 0 ? "Invalid maintenance" : "");
            setMaintenance(Number(val));
          }}
          className="w-full h-[42px] rounded border pl-6 pr-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
        />
      </div>
      {maintenanceError && <p className="text-xs text-red-600 mt-1">{maintenanceError}</p>}
    </div>

    
    <div className="w-full">
      <label className="text-sm font-medium text-gray-700 mb-1 block">Other Cost</label>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
        <input
          type="text"
          value={otherCosts.toLocaleString()}
          onChange={(e) => {
            const val = e.target.value.replace(/[^0-9]/g, "");
            setOtherCostsError(!val || Number(val) < 0 ? "Invalid Other Cost" : "");
            setOtherCosts(Number(val));
          }}
          className="w-full h-[42px] rounded border pl-6 pr-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
        />
      </div>
      {otherCostsError && <p className="text-xs text-red-600 mt-1">{otherCostsError}</p>}
    </div>






    

    
   

    {/* Expense Appreciation */}
    <div className="w-full">
      <label className="text-sm font-medium text-gray-700 mb-1 block">Annual Expense Increase (%)</label>
      <div className="relative">
        <input
          type="number"
          step="any"
          value={expenseIncrease.toLocaleString()}
          onChange={(e) => setExpenseIncrease(Number(e.target.value))}
          className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300
          [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">%</span>
      </div>
    </div>

  </div>
</div>



{/* Sell Section */}
<div className="mb-6">
  <h3 className="text-lg font-semibold text-gray-700 mb-2">Sell</h3>

  {/* Toggle Choice */}
  <div className="flex items-center gap-4 mb-4">
    <span className="text-sm text-gray-700">Do you know the selling price?</span>
    <label className="flex items-center gap-1 text-sm">
      <input
        type="radio"
        checked={knowSellPrice}
        onChange={() => setKnowSellPrice(true)}
      />
      Yes
    </label>
    <label className="flex items-center gap-1 text-sm">
      <input
        type="radio"
        checked={!knowSellPrice}
        onChange={() => setKnowSellPrice(false)}
      />
      No
    </label>
  </div>

  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    {/* Conditional Input: Selling Price or Appreciation */}
    {knowSellPrice ? (
      <div className="w-full">
        <label className="text-sm font-medium text-gray-700 mb-1 block">Selling Price</label>
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
          <input
            type="text"
            value={sellingPrice.toLocaleString()}
            onChange={(e) => {
              const val = e.target.value.replace(/[^0-9]/g, "");
              setSellingPrice(Number(val));
            }}
            className="w-full h-[42px] rounded border pl-6 pr-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
          />
        </div>
      </div>
    ) : (
      <div className="w-full">
        <label className="text-sm font-medium text-gray-700 mb-1 block">Annual Appreciation (%)</label>
        <div className="relative">
          <input
            type="number"
            step="any"
            value={valueAppreciation.toLocaleString()}
            onChange={(e) => setValueAppreciation(Number(e.target.value))}
            className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300
          [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">%</span>
        </div>
      </div>
    )}

    {/* Holding Length */}
    <div className="w-full">
      <label className="text-sm font-medium text-gray-700 mb-1 block">Holding Length (Years)</label>
      <input
        type="number"
        value={holdingLength.toLocaleString()}
        onChange={(e) => setHoldingLength(Number(e.target.value))}
        className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300"
      />
    </div>

    {/* Cost to Sell */}
    <div className="w-full">
      <label className="text-sm font-medium text-gray-700 mb-1 block">Cost to Sell (%)</label>
      <div className="relative">
        <input
          type="number"
          step="any"
          value={costToSell.toLocaleString()}
          onChange={(e) => setCostToSell(Number(e.target.value))}
          className="w-full h-[42px] rounded border px-3 py-2 focus:outline-none focus:ring-2 border-gray-300
          [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">%</span>
      </div>
    </div>
  </div>
</div>




{/* Results Section */}
<div className="mt-8 border-t pt-6 overflow-hidden">
  <h3 className="text-xl font-bold text-gray-800 mb-4">First Year Income and Expense</h3>
  <div className="rounded-lg overflow-hidden border border-gray-300">
  <table className="w-full text-sm text-right border-collapse">
    <thead className="bg-blue-800 text-white text-sm rounded-br-lg">
      <tr>
        <th className="py-2 px-3 text-left rounded-tl-lg ">Category</th>
        <th className="py-2 px-3 text-left">Monthly</th>
        <th className="py-2 px-3 text-left rounded-tr-lg">Annual</th>
      </tr>
    </thead>
    <tbody>
      <tr className="bg-white">
        <td className="py-1 px-3 text-left border-r border-gray-50">Income:</td>
        <td className="text-left border-r border-gray-50">${((monthlyRent + otherIncome).toLocaleString(undefined, { maximumFractionDigits: 0 }))}</td>
        <td className="text-left">${((monthlyRent + otherIncome) * 12).toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
      </tr>
      <tr className="bg-gray-200">
        <td className="py-1 px-3 text-left border-r border-gray-300 ">Mortgage Pay:</td>
        <td className="text-left border-r border-gray-300 ">${monthlyLoanPayment.toLocaleString(undefined, { maximumFractionDigits: 1 })}</td>
        <td className="text-left">${annualLoanPayment.toLocaleString(undefined, { maximumFractionDigits: 1 })}</td>
      </tr>
      <tr className="bg-white">
        <td className="py-1 px-3 text-left border-r border-gray-50">Vacancy ({vacancyRate}%):</td>
        <td className="text-left border-r border-gray-50">${((monthlyRent + otherIncome) * (vacancyRate / 100)).toFixed(2)}</td>
        <td className="text-left border-r border-gray-50">${((monthlyRent + otherIncome) * 12 * (vacancyRate / 100)).toFixed(2)}</td>
      </tr>
      <tr className="bg-gray-200">
        <td className="py-1 px-3 text-left border-r border-gray-300 ">Property Management Fee ({propertyManagement}%):</td>
        <td className="text-left border-r border-gray-300 ">${(totalManagementCost/12).toFixed(2)}</td>
        <td className="text-left border-r border-gray-300 ">${(totalManagementCost).toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
      </tr>
      <tr className="bg-white">
        <td className="py-1 px-3 text-left border-r border-gray-50">HOA Fee :</td>
        <td className="text-left border-r border-gray-50">${(hoaFee).toFixed(2)}</td>
        <td className="text-left border-r border-gray-50">${(hoaFee*12).toFixed(2)}</td>
      </tr>
      <tr className="bg-gray-200">
        <td className="py-1 px-3 text-left border-r border-gray-300 ">Property Tax:</td>
        <td className="text-left border-r border-gray-300 ">${(propertyTax / 12).toLocaleString(undefined, { maximumFractionDigits: 1 })}</td>
        <td className="text-left border-r border-gray-300 ">${propertyTax.toLocaleString(undefined, { maximumFractionDigits: 1 })}</td>
      </tr>
      <tr className="bg-white">
        <td className="py-1 px-3 text-left border-r border-gray-50">Total Insurance:</td>
        <td className="text-left border-r border-gray-50">${(insurance / 12).toLocaleString(undefined, { maximumFractionDigits: 1 })}</td>
        <td className="text-left border-r border-gray-50">${insurance.toLocaleString(undefined, { maximumFractionDigits: 1 })}</td>
      </tr>
      <tr className="bg-gray-200">
        <td className="py-1 px-3 text-left border-r border-gray-300 ">Maintenance Cost:</td>
        <td className="text-left border-r border-gray-300 ">${(maintenance / 12).toLocaleString(undefined, { maximumFractionDigits: 1 })}</td>
        <td className="text-left border-r border-gray-300 ">${maintenance.toLocaleString(undefined, { maximumFractionDigits: 1 })}</td>
      </tr>
      <tr className="bg-white">
        <td className="py-1 px-3 text-left border-r border-gray-50">Other Cost:</td>
        <td className="text-left border-r border-gray-50">${(otherCosts / 12).toLocaleString(undefined, { maximumFractionDigits: 1 })}</td>
        <td className="text-left border-r border-gray-50">${otherCosts.toLocaleString(undefined, { maximumFractionDigits: 1 })}</td>
      </tr>
      <tr className={`font-bold bg-gray-100 border-r border-gray-300 ${annualCashFlow < 0 ? 'text-red-600' : 'text-green-600'}`}>
        <td className="py-1 px-3 text-left border-r border-gray-200 ">Cash Flow:</td>
        <td className="text-left border-r border-gray-200 ">{annualCashFlow < 0 ? `-$${Math.abs(annualCashFlow / 12).toFixed()}` : `$${(annualCashFlow / 12).toLocaleString(undefined, { maximumFractionDigits: 1 })}`}</td>
        <td className="text-left border-r border-gray-200 ">{annualCashFlow < 0 ? `-$${Math.abs(annualCashFlow).toFixed()}` : `$${annualCashFlow.toLocaleString(undefined, { maximumFractionDigits: 1 })}`}</td>
      </tr>
      <tr className="font-bold bg-green-100 border-r border-gray-300">
        <td className="py-1 px-3 text-left rounded-bl-md border-r border-gray-100">Net Operating Income (NOI):</td>
        <td className="text-left border-r border-gray-100 ">${((adjustedGrossIncome - operatingExpenses) / 12).toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
        <td className="text-left border-r border-gray-300 ">${(adjustedGrossIncome - operatingExpenses).toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
      </tr>
    </tbody>
  </table>
  </div>


  <h3 className="mt-6 text-xl font-bold text-gray-800 mb-4">For the {holdingLength} Years Invested</h3>
  <div className="rounded-lg overflow-hidden border border-gray-300">
  <table className="w-full text-sm text-right border-collapse">
    <thead className="bg-blue-800 text-white text-sm rounded-br-lg">
      <tr>
        <th className="py-2 px-3 text-left rounded-tl-lg ">Return Matrix</th>
        <th className="py-2 px-3 text-left">Result</th>
      </tr>
    </thead>
          <tbody>
            <tr className="bg-gray-200">
              <td className="py-1 px-3 text-left border-r border-gray-300 font-semibold">Total Profit when Sold:<br />(Total Home Price + Net Cash Flow - Loan Balance)</td>
              <td className={`text-left font-semibold ${totalProfit < 0 ? 'text-red-600' : 'text-green-600'}`}>${totalProfit.toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
            </tr>
            <tr>
              <td className="py-1 px-3 text-left font-medium border-r border-gray-50">Return (IRR) Per Year:</td>
              <td className={`text-left font-semibold ${irr < 0 ? 'text-red-600' : 'text-green-600'}`}>{irr.toFixed(2)}%</td>
            </tr>
            <tr className="bg-gray-200">
              <td className="py-1 px-3 font-medium text-left border-r border-gray-300 ">Cash on Cash Return:</td>
              <td className={`text-left font-semibold ${cashOnCashReturn < 0 ? 'text-red-600' : 'text-green-600'}`}>{cashOnCashReturn.toFixed(2)}%</td>
            </tr>
            <tr>
              <td className="py-1 px-3 text-left font-medium border-r border-gray-50">Capitalization Rate:</td>
              <td className={`text-left font-semibold ${capRate < 0 ? 'text-red-600' : 'text-green-600'}`}>{capRate.toFixed(2)}%</td>
            </tr>
            
            <tr className="bg-gray-200">
              <td className="py-1 px-3 text-left border-r border-gray-300">Total Home Price When Sold:</td>
              <td className="text-left text-green-600 font-semibold">${projectedSellingPrice.toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
            </tr>
            <tr>
              <td className="py-1 px-3 text-left border-r border-gray-50">Loan Balance When Sold:</td>
              <td className="text-left text-red-600 font-semibold">${remainingLoanBalance .toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
            </tr>
            <tr className="bg-gray-200">
              <td className="py-1 px-3 text-left border-r border-gray-300">Total Equity Accumulated:</td>
              <td className='text-left text-green-600 font-semibold'>${(projectedSellingPrice - remainingLoanBalance).toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
            </tr>
        
            <tr >
              <td className="py-1 px-3 text-left border-r border-gray-50"  >Total Rental Income:</td>
              <td className = 'text-left font-semibold text-green-600'>${totalRentalIncome.toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
            </tr>
            <tr className="bg-gray-200">
              <td className="py-1 px-3 text-left border-r border-gray-300">Total Mortgage Payments:</td>
              <td className="text-left font-semibold text-red-600">${totalLoanPayments.toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
            </tr>
            <tr >
              <td className="py-1 px-3 text-left border-r border-gray-50">Total Expenses:<br/>(Management Fee + Property Tax + HOA + Maintenance Cost + Other Cost)</td>
              <td className="text-left font-semibold text-red-600">${totalOperatingExpenses.toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
            </tr>
            <tr className="bg-gray-200">
              <td className="py-1 px-3 text-left border-r border-gray-300">Total Net Operating Income(NOI):</td>
              <td className = 'text-left font-semibold text-green-600'>${totalNOI.toLocaleString(undefined, { maximumFractionDigits: 0 })}</td>
            </tr>
          </tbody>
        </table>
        </div>
</div>



</div>
);
};

export default RentalCalculator;